import React, { useState, useEffect, Suspense } from 'react';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import theme from '../theme/theme';
import Header from '../header/Header';
import Workarea from '../workarea/Workarea';
import CssBaseline from '@mui/material/CssBaseline';
import NotificationsPane from '../notifications/NotificationsPane';
import { useLocation } from 'react-router';
import { LicenseInfo } from '@mui/x-license';
import { QueryClientProvider, QueryErrorResetBoundary } from '@tanstack/react-query';
import queryClient from './queryClient';
import SplashScreen from '../splashScreen/SplashScreen';
import NotificationsProvider from '../notifications/NotificationsProvider';
import { msalInstance } from '../msalConfig';
import { MsalProvider } from '@azure/msal-react';
import { TourProvider } from '../tourContext/TourContext';
import { ErrorBoundary } from 'react-error-boundary';
import AuthLoader from './AuthLoader';
import GlobalErrorFallback from './GlobalErrorFallback';

LicenseInfo.setLicenseKey('febb1cae698c78eb24770a8389cf04eeTz0xMDMzMzAsRT0xNzY0NzU2NzU0MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

const App = () => {
  const [showNotifications, setShowNotifications] = useState(false);

  const location = useLocation();
  useGoogleAnalytics();

  useEffect(() => {
    setShowNotifications(false);
  }, [location]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <QueryClientProvider client={queryClient}>
          <QueryErrorResetBoundary>
            {({ reset }) => (
              <ErrorBoundary onReset={reset} fallbackRender={GlobalErrorFallback}>
                <Suspense fallback={<SplashScreen />}>
                  <AuthLoader>
                    <TourProvider>
                      <NotificationsProvider>
                        <MsalProvider instance={msalInstance}>
                          <Header onToggleNotifications={() => setShowNotifications(!showNotifications)} />
                          <Workarea />
                          <NotificationsPane
                            isOpen={showNotifications}
                            onClose={() => setShowNotifications(false)}
                          />
                        </MsalProvider>
                      </NotificationsProvider>
                    </TourProvider>
                  </AuthLoader>
                </Suspense>
              </ErrorBoundary>
            )}
          </QueryErrorResetBoundary>
        </QueryClientProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;